<script setup>
import { ref, computed, defineEmits } from 'vue';
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import Checkbox from '@/components/CheckboxButton.vue';

defineProps({
  visible: Boolean,
});

const emit = defineEmits(['close', 'success']);

const permissions = ref({
  manage_users: false,
  driver: false,
});

const updatePermission = (key, value) => {
  permissions.value[key] = value;
};

const checkboxes = computed(() => [
  { key: 'manage_users', label: 'Manage Users' },
  { key: 'driver', label: 'Driver' },
]);

const handleSubmit = () => {
  const scopes = ['onboarding'];
  if (permissions.value.manage_users) scopes.push('manage_users');
  if (permissions.value.driver) scopes.push('driver');

  emit('success', scopes);
};
</script>

<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="emit('close')"
  >
    <div class="flex justify-center">
      <div
        class="relative rounded bg-white p-4"
        style="width: 400px"
      >
        <section class="mb-4 flex items-center justify-between">
          <h3 class="text-left text-base text-dark-gray">
            Assign additional permissions to this user
          </h3>
          <svg
            class="cursor-pointer"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            @click="emit('close')"
          >
            <path
              d="M18.364 7.05044L16.9498 5.63623L12 10.586L7.05026 5.63623L5.63605 7.05044L10.5858 12.0002L5.63605 16.9499L7.05026 18.3642L12 13.4144L16.9498 18.3642L18.364 16.9499L13.4142 12.0002L18.364 7.05044Z"
              fill="#6C7C9D"
            />
          </svg>
        </section>

        <div class="mt-4">
          <label class="text-2xs font-bold uppercase"
            >Permissions (Optional)</label
          >
          <div
            v-for="box in checkboxes"
            :key="box.key"
          >
            <Checkbox
              :item="box.label"
              :active-val="permissions[box.key]"
              :handle-select="(value) => updatePermission(box.key, value)"
            />
          </div>
        </div>

        <section class="mt-4 flex gap-3">
          <button-main
            variant="secondary"
            @click="emit('close')"
            >Go Back</button-main
          >
          <button-main @click="handleSubmit">Confirm</button-main>
        </section>
      </div>
    </div>
  </modal>
</template>

<style scoped>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Para Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
